var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaptopClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_146_1246)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.47656 6.87109C4.47656 7.50513 4.72843 8.11319 5.17676 8.56152C5.62509 9.00985 6.23315 9.26172 6.86719 9.26172C7.50122 9.26172 8.10929 9.00985 8.55761 8.56152C9.00594 8.11319 9.25781 7.50513 9.25781 6.87109C9.25781 6.23706 9.00594 5.629 8.55761 5.18067C8.10929 4.73234 7.50122 4.48047 6.86719 4.48047C6.23315 4.48047 5.62509 4.73234 5.17676 5.18067C4.72843 5.629 4.47656 6.23706 4.47656 6.87109Z",
    stroke: "currentColor",
    strokeWidth: 0.735577,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.92824 6.875H6.87158V5.81834M1.19385 4.7832V0.898438C1.19385 0.739929 1.25681 0.587913 1.3689 0.475831C1.48098 0.363748 1.633 0.300781 1.7915 0.300781H7.76807C7.92657 0.300781 8.07859 0.363748 8.19067 0.475831C8.30276 0.587913 8.36572 0.739929 8.36572 0.898438V3.28906M3.8833 4.7832H0.297363C0.297363 5.17947 0.454781 5.55951 0.734987 5.83972C1.01519 6.11993 1.39523 6.27734 1.7915 6.27734H3.28564",
    stroke: "currentColor",
    strokeWidth: 0.735577,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_146_1246"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.5625,
    height: 9.5625,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptopClock);
export default __webpack_public_path__ + "static/media/laptop-clock.301e6ccd5a5ac3c74283ae3b36bb40b5.svg";
export { ForwardRef as ReactComponent };